"use strict";

export default function () {
    const hamburguer = document.querySelector(".hamburguer-menu");
    const hiddenScroll = document.querySelector("body");
    const header = document.querySelector(".o-header");
    const menu = document.querySelector(".mobile-menu");
    hamburguer.addEventListener("click", () => {
        header.classList.remove("active");
        menu.classList.toggle("active");
        hiddenScroll.style.overflow = menu.classList.contains("active")
            ? "hidden"
            : "auto";
        header.style.position = menu.classList.contains("active")
            ? "fixed"
            : "fixed";
    });
}
